import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import EdButton from "@frameworks/web/components//generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import { alphabetExp, emailRegex, pan } from "@frameworks/web/utils/regex";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import di from "../di/servicelocator";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ChooseAccountForLogin } from "../ClientUser/chooseAccntForLogin";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import { handleNavigateUrl, loginScreenState, unblockUserState, } from "../constant";
import UnblockAccountMsg from "./UnblockAccountMsg";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
const inputfield = {
    name: "",
    pan: "",
    email: "",
};
const UnblockAccount = (props) => {
    const device = DeviceContext();
    const redirectUrlFromQueryParams = getQueryParameterName("redirectUrl");
    const [formData, setFormData] = useState(inputfield);
    const [apicall, setApicall] = useState(false);
    const [loginButtonDisable, setLoginDisable] = React.useState(false);
    const [screenState, setScreenState] = React.useState(unblockUserState.UNBLOCK_USER);
    let navigate = useNavigate();
    const handleChange = (event) => {
        if (event.target.name === "name" || event.target.name === "pan")
            setFormData(Object.assign(Object.assign({}, formData), { [event.target.name]: event.target.value.toUpperCase() }));
        else
            setFormData(Object.assign(Object.assign({}, formData), { [event.target.name]: event.target.value }));
        if (loginButtonDisable)
            setLoginDisable(false);
    };
    const [error, setError] = useState(inputfield);
    const [accountType, setAccountType] = useState();
    const validationError = (field, value) => {
        setError(Object.assign(Object.assign({}, error), { [field]: value }));
    };
    const { data: unblockAccount, loader: unblockAccountLoader, errorData: unblockAccountError, } = useSelector((state) => state.LoginFlow.unblockUser);
    const getUnBlockedAccount = () => {
        let req = {
            userId: formData.name,
            email: formData.email,
            pan: formData.pan,
            accTyp: accountType,
        };
        di.login.getUnblockUserDetails(req);
        setApicall(true);
    };
    const handleScreens = () => {
        switch (screenState) {
            case unblockUserState.UNBLOCK_USER:
                return (React.createElement("div", { className: "unbloackaccount p-3 bg-white" },
                    React.createElement("form", { id: "unblockAccount-form", onSubmit: (e) => {
                            e.preventDefault();
                        } },
                        React.createElement(Row, null,
                            (device === null || device === void 0 ? void 0 : device.isDesktop) ? ("") : (React.createElement(React.Fragment, null,
                                React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansBold_20_700" }, "Unblock your account"))),
                            React.createElement(ChooseAccountForLogin, { setAccountType: setAccountType, noGridContainer: true }),
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-4 mt-md-5" },
                                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.name, onBlur: (error, event) => {
                                        if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.name, placeholder: "Enter your login ID", id: "name", highlightInputField: true, name: "name", alphanum: true, pattern: alphabetExp, required: true, autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control" })),
                            React.createElement(Col, { lg: 12 },
                                React.createElement("div", { className: "d-flex justify-content-end" },
                                    React.createElement(EdButton, { btnTyp: "link", className: "no_bg underline cursor d-flex justify-content-end small-edbutton txt-midnight-blue mt-2 cursorOnHover", onClick: () => {
                                            di.login.flushLoginError();
                                            if (props.helpFlowPopup) {
                                                props.helpFlowPopup(loginScreenState.FORGOT_LOGIN_ID);
                                            }
                                            else {
                                                navigate(handleNavigateUrl("/forgot-loginId", redirectUrlFromQueryParams), {
                                                    replace: true,
                                                });
                                            }
                                        }, value: "Forgot login ID?" }))),
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-4 mt-md-5" },
                                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.email, pattern: emailRegex, onBlur: (error, event) => {
                                        if (!error.pattern)
                                            validationError(event.target.name, "Enter valid Email Id");
                                        else if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.email, highlightInputField: true, placeholder: "Enter your email address", id: "email", name: "email", required: true, autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control" })),
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5 mt-md-5" },
                                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.pan, pattern: pan, onBlur: (error, event) => {
                                        if (!error.pattern)
                                            validationError(event.target.name, "Enter valid PAN Number");
                                        else if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.pan, highlightInputField: true, placeholder: "Enter your PAN", id: "pan", name: "pan", required: true, autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control" }))),
                        !unblockAccountLoader &&
                            unblockAccountError.isOpen &&
                            loginButtonDisable && (React.createElement(ErrorExclamation, { avoidExclamation: true, errorMessage: unblockAccountError.error
                                .getErrorMessageOrErrMsg()
                                .replace("NOT_OK : ", ""), parentClass: "login-errorMsg-section" })),
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5 mt-md-5 mb-3" },
                                React.createElement(EdButton, { value: "Unblock", className: "w-100", disabled: !(formData.email &&
                                        formData.name &&
                                        formData.pan.length == 10) ||
                                        !(!error.name && !error.email && !error.pan) ||
                                        unblockAccountLoader ||
                                        !accountType ||
                                        loginButtonDisable, btnTyp: "midnight-blue", onClick: getUnBlockedAccount, type: "submit" }))))));
            case unblockUserState.SUCCESS_STATE:
                return (React.createElement(UnblockAccountMsg, { helpFlowPopup: props.helpFlowPopup, redirectUrlFromQueryParams: redirectUrlFromQueryParams }));
        }
    };
    useEffect(() => {
        if (screenState) {
            handleScreens();
        }
    }, [screenState]);
    useEffect(() => {
        if (!unblockAccountLoader && !unblockAccountError.isOpen) {
            if (unblockAccount.success && apicall) {
                setScreenState(unblockUserState.SUCCESS_STATE);
            }
        }
        else if (!unblockAccountLoader && unblockAccountError.isOpen) {
            setLoginDisable(true);
        }
    }, [unblockAccountError, unblockAccountLoader, unblockAccount, apicall]);
    return React.createElement(React.Fragment, null, handleScreens());
};
export default UnblockAccount;
